import { tVariants } from '../../style-system';
import { factoryStyleProps } from '../../style-system/factory/style-props';

const cardStyles = tVariants(
    {
        base: 'bg-surface rounded-md block',
        variants: {
            withBorder: {
                true: 'border border-surface-divider',
            },
            href: {
                true: 'transition-colors hover:border-surface-selected',
            },
            borderRadius: factoryStyleProps.border.borderRadius,
            ...factoryStyleProps.__atoms.layout.position,
            ...factoryStyleProps.__atoms.layout.flex,
            ...factoryStyleProps.__atoms.layout.overflow,
            ...factoryStyleProps.space,
            ...factoryStyleProps.size,
        },
    },
    { responsiveVariants: true },
);

export { cardStyles };
